import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

const USERNAME_PATTERN = /^[A-Za-z0-9._-]{3,32}$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 32px 16px;
  background: var(--design-bg);
  color: var(--design-text);
  font-family: SUIT, Arial, sans-serif;
}

.auth-panel {
  width: min(760px, 100%);
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  padding: 28px;
  box-shadow: var(--design-shadow-strong);
}

.auth-back,
.auth-links a {
  color: var(--design-source);
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.auth-heading {
  margin: 22px 0 20px;
}

.auth-heading p {
  margin: 0 0 8px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 700;
}

.auth-heading h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
}

.auth-notice {
  margin: 0 0 18px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  padding: 12px 13px;
  background: var(--design-card-tinted);
  color: var(--design-text);
}

.auth-notice strong {
  display: block;
  margin-bottom: 4px;
  color: var(--design-accent);
  font-size: 13px;
  font-weight: 800;
}

.auth-notice span {
  display: block;
  font-size: 13px;
  line-height: 1.55;
}

.auth-form {
  display: grid;
  gap: 14px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.form-field {
  display: grid;
  gap: 7px;
  font-size: 13px;
  font-weight: 700;
}

.form-field small {
  color: var(--design-text-muted);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
}

.form-field em {
  color: #b42318;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.auth-form input,
.auth-form textarea {
  width: 100%;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px 13px;
  font-size: 14px;
  outline: none;
  resize: vertical;
}

.auth-form input:focus,
.auth-form textarea:focus {
  border-color: var(--design-accent);
  box-shadow: var(--design-focus-ring);
}

.form-field.is-invalid input,
.form-field.is-invalid textarea {
  border-color: #d92d20;
  background: #fffafa;
}

.auth-error,
.auth-success {
  margin: 0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 700;
}

.auth-error {
  border: 1px solid #f3b7b1;
  background: #fff4f2;
  color: #b42318;
}

.auth-success {
  border: 1px solid rgba(94, 102, 118, 0.28);
  background: rgba(94, 102, 118, 0.1);
  color: var(--design-olive);
}

.auth-submit {
  border: 1px solid var(--design-accent);
  border-radius: 8px;
  padding: 12px 14px;
  background: var(--design-accent);
  color: var(--design-on-accent);
  font-size: 14px;
  font-weight: 800;
}

.auth-submit:disabled {
  opacity: 0.55;
}

.auth-links {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 700px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
/* Review 122: align auth screens with the clean neutral CTA system. */
.auth-page {
  background: #FFFFFF;
  color: var(--design-body-text, #2B2B2B);
}

.auth-panel {
  border-color: #E5E5E5;
  background: #FFFFFF;
  box-shadow: 0 8px 22px rgba(30, 30, 30, 0.04);
}

.auth-back,
.auth-links a {
  color: #536C7A;
}

.auth-back:hover,
.auth-back:focus-visible,
.auth-links a:hover,
.auth-links a:focus-visible {
  color: #1F1F1F;
  outline: none;
}

.auth-notice {
  border-color: #E5E5E5;
  background: #FAFAFA;
}

.auth-form input,
.auth-form textarea {
  border-color: #E5E5E5;
  background: #FFFFFF;
  color: #2B2B2B;
}

.auth-form input:focus,
.auth-form textarea:focus {
  border-color: rgba(30, 30, 30, 0.22);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.auth-success {
  border-color: rgba(94, 102, 118, 0.26);
  background: rgba(94, 102, 118, 0.1);
  color: #4F5662;
}

.auth-submit {
  border-color: #1F1F1F;
  background: #1F1F1F;
  color: #FFFFFF;
  box-shadow: none;
}

.auth-submit:not(:disabled):hover,
.auth-submit:not(:disabled):focus-visible {
  border-color: #111111;
  background: #111111;
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.auth-submit:disabled {
  border-color: #E5E5E5;
  background: #F5F5F5;
  color: #666666;
  opacity: 1;
  cursor: not-allowed;
}

/* Review 124: signup remains the primary CTA. */
.auth-submit {
  border-color: #1F1F1F;
  background: #1F1F1F;
  color: #FFFFFF;
}

.auth-submit:not(:disabled):hover,
.auth-submit:not(:disabled):focus-visible {
  border-color: #343434;
  background: #343434;
  color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.auth-submit:disabled {
  border-color: #E5E5E5;
  background: #F5F5F5;
  color: #A0A0A0;
}`],
})
export class PageSignupComponent implements OnInit {
    public form: any = {
        username: '',
        password: '',
        password_confirm: '',
        name: '',
        email: '',
        organization: '',
        position: '',
        purpose: '',
    };
    public loading: boolean = false;
    public errorMessage: string = '';
    public successMessage: string = '';
    public fieldErrors: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status && this.service.auth.session?.status === 'active') {
            this.service.href('/main');
            return;
        }
        await this.service.render();
    }

    public responseMessage(response: any, fallback: string = '요청을 처리하지 못했습니다.'): string {
        let data = response?.data;
        if (typeof data === 'string') return data;
        if (data?.message) return data.message;
        return fallback;
    }

    public clearFieldError(field: string) {
        if (!this.fieldErrors[field]) return;
        delete this.fieldErrors[field];
    }

    public normalizedForm(): any {
        return {
            username: `${this.form.username || ''}`.trim(),
            password: `${this.form.password || ''}`,
            password_confirm: `${this.form.password_confirm || ''}`,
            name: `${this.form.name || ''}`.trim(),
            email: `${this.form.email || ''}`.trim(),
            organization: `${this.form.organization || ''}`.trim(),
            position: `${this.form.position || ''}`.trim(),
            purpose: `${this.form.purpose || ''}`.trim(),
        };
    }

    public validate(): boolean {
        const data = this.normalizedForm();
        const errors: any = {};
        const requiredMessages: any = {
            username: '아이디를 입력해주세요.',
            password: '비밀번호를 입력해주세요.',
            password_confirm: '비밀번호 확인을 입력해주세요.',
            name: '이름을 입력해주세요.',
            email: '이메일을 입력해주세요.',
            organization: '소속을 입력해주세요.',
            position: '직책 또는 역할을 입력해주세요.',
            purpose: '가입 목적 또는 사용 목적을 입력해주세요.',
        };

        for (let field of Object.keys(requiredMessages)) {
            if (!data[field]) {
                errors[field] = requiredMessages[field];
            }
        }

        if (data.username && !USERNAME_PATTERN.test(data.username)) {
            errors.username = '아이디는 영문, 숫자, 점, 밑줄, 하이픈 조합 3~32자로 입력해주세요.';
        }
        if (data.password && data.password.length < 8) {
            errors.password = '비밀번호는 8자 이상으로 입력해주세요.';
        }
        if (data.password && data.password_confirm && data.password !== data.password_confirm) {
            errors.password_confirm = '비밀번호 확인이 일치하지 않습니다.';
        }
        if (data.email && !EMAIL_PATTERN.test(data.email)) {
            errors.email = '이메일 형식에 맞게 입력해주세요.';
        }

        this.fieldErrors = errors;
        this.form = data;
        this.errorMessage = Object.keys(errors).length > 0 ? '입력값을 확인해주세요.' : '';
        return Object.keys(errors).length === 0;
    }

    public applyServerError(message: string) {
        if (message.indexOf('이미 사용 중인 아이디') >= 0) {
            this.fieldErrors.username = message;
            return;
        }
        if (message.indexOf('비밀번호 확인') >= 0) {
            this.fieldErrors.password_confirm = message;
            return;
        }
        if (message.indexOf('비밀번호') >= 0) {
            this.fieldErrors.password = message;
            return;
        }
        if (message.indexOf('필수') >= 0) {
            this.fieldErrors.purpose = message;
        }
    }

    public async submit() {
        this.errorMessage = '';
        this.successMessage = '';
        this.fieldErrors = {};

        if (!this.validate()) {
            await this.service.render();
            return;
        }

        this.loading = true;
        await this.service.render();

        let response = await wiz.call('register', this.normalizedForm());
        this.loading = false;
        if (response.code === 200) {
            this.successMessage = '회원가입 신청이 접수되었습니다. 관리자 승인 후 이용할 수 있습니다.';
            await this.service.render();
            setTimeout(() => window.location.href = response.data?.redirect || '/pending', 600);
            return;
        }
        this.errorMessage = this.responseMessage(response, '회원가입 신청을 저장하지 못했습니다.');
        this.applyServerError(this.errorMessage);
        await this.service.render();
    }
}

export default PageSignupComponent;